exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-246c43c0]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-246c43c0]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-246c43c0]{margin-right:-20px;padding-right:10px}[dir] .settings-section[data-v-246c43c0]{margin-bottom:16px}.settings-section-header[data-v-246c43c0]{flex-direction:column;align-items:flex-start}.settings-section-title[data-v-246c43c0]{font-weight:500}[dir] .settings-section-title[data-v-246c43c0]{margin:0}.settings-section-desc[data-v-246c43c0]{font-size:13px;color:rgba(0,0,0,.54)}[dir] .settings-section-desc[data-v-246c43c0]{margin:4px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-246c43c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/settings.vue
// module id = 1238
// module chunks = 0